import { useStaticQuery, graphql } from 'gatsby'
import { useLocale } from '@plugins/bw-i18next/utils'

export type AnyLinkType = Queries.CtaLinkFragment | Queries.HeaderDropdownMenuFragment | Queries.HeaderRichMenuFragment

export const flattenLinkGroups = (links: Queries.HeaderFragment['mainNavItems']) =>
  links?.reduce((acc, link) => {
    if (link.__typename === 'ContentfulHeaderLinkGroup') {
      return [...acc, ...link.links]
    }
    return [...acc, link]
  }, [] as AnyLinkType[]) || []

const useFindHeaderWithLocale = (query: Queries.StaticHeadersQuery['defaultHeaderQuery']) => {
  const locale = useLocale()
  return query.nodes.find((header) => header.node_locale === locale.currentContentfulCode)
}

const useStaticHeaders = () => {
  const query: Queries.StaticHeadersQuery = useStaticQuery(graphql`
    query StaticHeaders {
      defaultHeaderQuery: allContentfulHeader(filter: { isDefault: { eq: true } }) {
        nodes {
          ...Header
        }
      }
      whiteGoHeaderQuery: allContentfulHeader(filter: { contentful_id: { eq: "7ykOpxmhJ4f3qJ3qwqGGK1" } }) {
        nodes {
          ...Header
        }
      }
      blueGoHeaderQuery: allContentfulHeader(filter: { contentful_id: { eq: "2PWlO2FdpjxHZstu5gQwt7" } }) {
        nodes {
          ...Header
        }
      }
    }
  `)
  return query
}

export const useDefaultHeader = () => {
  const query = useStaticHeaders()
  return useFindHeaderWithLocale(query.defaultHeaderQuery)
}

export const useWhiteGoHeader = () => {
  const query = useStaticHeaders()
  return useFindHeaderWithLocale(query.whiteGoHeaderQuery)
}

export const useBlueGoHeader = () => {
  const query = useStaticHeaders()
  return useFindHeaderWithLocale(query.blueGoHeaderQuery)
}
